import { Component, ViewEncapsulation } from '@angular/core';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';

@Component({
	selector: 'app-customer',
	templateUrl: './customer.component.html',
	styleUrls: ['./customer.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CustomerComponent {
	customerInfo: any = null;

	constructor(
		private sharedDataService: SharedDataService
	) {
		this.sharedDataService.asObservable().subscribe((data) => {
			if (data && data.customerInfo) {
				this.customerInfo = data.customerInfo
			}
		});
	}

	ngOnInit(): void { }

	ngAfterViewInit() {
		document.getElementById('page-footer').classList.remove('d-none');
	}
}